import { Scene } from '@babylonjs/core/scene';
import { KbViewer } from '@view/kb-viewer';

export class RightClickMenu {
    constructor(private viewer: KbViewer, private scene: Scene) {}

    isOpen() {
        return this.contextMenuOpen;
    }

    private contextmenu?: HTMLDivElement;
    private contextMenuOpen = false;

    showContextMenu(xPosition: number, yPosition: number, buttons: Array<{ label: string; callback: () => void }>) {
        this.createContextMenu(xPosition, yPosition, buttons);
        if (this.viewer.uiOverlay && this.contextmenu) {
            this.viewer.container.appendChild(this.contextmenu);
            this.contextMenuOpen = true;
        }
    }

    hideContextMenu() {
        if (this.contextmenu) {
            this.contextmenu.style.display = 'none';
            this.contextMenuOpen = false;
        }
    }

    private createContextMenu(
        xPosition: number,
        yPosition: number,
        buttons: Array<{ label: string; callback: () => void }>
    ) {
        //const buttons = [];
        if (this.contextmenu && this.viewer.container.contains(this.contextmenu)) {
            this.viewer.container?.removeChild(this.contextmenu);
        }
        const contextMenu = document.createElement('div');
        contextMenu.style.position = 'absolute';
        contextMenu.style.top = yPosition.toString() + 'px';
        contextMenu.style.left = (xPosition + 10).toString() + 'px';
        contextMenu.style.width = 'auto';
        contextMenu.style.height = 'auto';
        contextMenu.style.zIndex = '2';
        contextMenu.addEventListener('click', e => {
            if (e.button === 2) {
                e.preventDefault();
                e.stopImmediatePropagation();
            }
        });
        document.addEventListener('click', e => {
            if (e.button != 2) {
                this.hideContextMenu();
            }
        });
        document.addEventListener('wheel', e => {
            this.hideContextMenu();
        });
        contextMenu.addEventListener('scroll', e => {
            if (this.contextmenu) {
                this.contextmenu.style.display = 'none';
            }
        });

        this.contextmenu = contextMenu;

        buttons.forEach(button => {
            const newButton = document.createElement('div');
            newButton.innerText = button.label;
            newButton.addEventListener('click', e => {
                button.callback();
                this.hideContextMenu();
            });
            this.contextmenu?.appendChild(newButton);
            newButton.style.zIndex = '100000';
            newButton.style.color = 'white';
            newButton.style.background = 'rgba(36,36,36,255)';
            newButton.style.cursor = 'pointer';
            newButton.style.padding = '10px';
            newButton.addEventListener('mouseover', e => {
                newButton.style.background = 'rgba(61,61,61,255)';
            });
            newButton.addEventListener('mouseout', e => {
                newButton.style.background = 'rgba(36,36,36,255)';
            });
        });
    }
}
